import React from 'react';
export var SelectionMarkerType;
(function (SelectionMarkerType) {
    SelectionMarkerType[SelectionMarkerType["SQUARE"] = 0] = "SQUARE";
    SelectionMarkerType[SelectionMarkerType["ROUND"] = 1] = "ROUND";
})(SelectionMarkerType || (SelectionMarkerType = {}));
export var ComponentContext = React.createContext(null);
//# sourceMappingURL=components-context.js.map